/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePromotionDto
 */
export interface UpdatePromotionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePromotionDto
     */
    nameEn?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePromotionDto
     */
    nameAr?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePromotionDto
     */
    active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePromotionDto
     */
    endsAt?: Date;
}

/**
 * Check if a given object implements the UpdatePromotionDto interface.
 */
export function instanceOfUpdatePromotionDto(value: object): value is UpdatePromotionDto {
    return true;
}

export function UpdatePromotionDtoFromJSON(json: any): UpdatePromotionDto {
    return UpdatePromotionDtoFromJSONTyped(json, false);
}

export function UpdatePromotionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePromotionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'active': json['active'] == null ? undefined : json['active'],
        'endsAt': json['endsAt'] == null ? undefined : (new Date(json['endsAt'])),
    };
}

export function UpdatePromotionDtoToJSON(value?: UpdatePromotionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'active': value['active'],
        'endsAt': value['endsAt'] == null ? undefined : ((value['endsAt'] as any).toISOString()),
    };
}

